const PDF_REQUEST_TYPES = {
  cem4601AdHoc: "CEM4601_ADHOC",
  cem4601Submit: "CEM4601_SUBMIT",
  cem4601Approve: "CEM4601_APPROVE",
};

export default PDF_REQUEST_TYPES;
